/** Backend / Dynamo expect this literal for workflow processing (templates, create, clone, edit). */
export const DEFAULT_WORKFLOW_TYPE_ODI = "odi";

export type WorkflowType = {
  Name: string;
  sourceLocationPath: string;
  BusinessUnitParticipant: string;
  DataFilePattern: string[];
  TriggerFilePattern: string[];
  Notification: NotificationType[];
  Scheduler: {};
  status: string;
  workflowType: string;
  workflowSteps: WorkflowStepsType[];
  TransferType: string;
  DeleteFiles: boolean;
  SourceLoacation: {};
};

export type NotificationType = {
  to: string;
  subject: string;
  notificationType: string;
  template: string;
  messageType: string;
};

export type WorkflowStepsType = {
  FunctionName: string;
  StepName: string;
  DeleteSourceFile: Boolean;
  DestinationFileInfo: FileInfoType;
  SourceFileInfo: FileInfoType;
  StepIndex: number;
  SecretName: string;
  SecretValue: Record<string, string>;
  InstitutionUuid?: string;
};

export type FileInfoType = {
  LocationType: string;
  StorageType: string;
  Path: string;
  Name: string;
  FileRename: Record<string, string>;
  BucketRename: string;
  SecretName: string;
};
